<script setup lang="ts">
withDefaults(
  defineProps<{
    severity?: 'info' | 'success' | 'warn' | 'error';
  }>(),
  {
    severity: 'info',
  },
);
</script>

<template>
  <p :class="severity">
    <slot />
  </p>
</template>

<style scoped>
p {
  font-weight: 500;
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
}

.error {
  color: #dc2626;
}

.info {
  color: #2477d6;
}

.warn {
  color: #ee8026;
}

.success {
  color: #2ba50c;
}
</style>
